"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import {
    load as loadIntercom,
    boot as bootIntercom,
    update as updateIntercom,
} from "./intercom";
import { useSession } from "next-auth/react";
import { api } from "./api";

type IntercomProviderProps = {
    children: React.ReactNode;
};

export const IntercomProvider = ({ children }: IntercomProviderProps) => {
    const pathname = usePathname();
    const { data: session, status } = useSession();
    const intercomUpdater = api.user.intercom.useMutation();

    useEffect(() => {
        if (typeof window !== "undefined") {
            loadIntercom();
            bootIntercom({}, session?.user);
            status === "authenticated" && intercomUpdater.mutateAsync();
        }
    }, [session]);

    useEffect(() => {
        if (typeof window !== "undefined") updateIntercom();
    }, [pathname]);

    return children;
};
